module.exports = __webpack_public_path__ + "img/01.12b791b3.jpg";